import i18n, { type ParseKeysByFallbackNs } from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import dictionaryEN from './locales/en'

const resources = {
    en: {
        translation: dictionaryEN,
    },
}

void i18n.use(LanguageDetector).use(initReactI18next).init({
    resources,
    fallbackLng: 'en',
})

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- external interface
    interface CustomTypeOptions {
        defaultNS: 'translation'
        resources: {
            translation: typeof dictionaryEN
        }
    }
}

/**
 * Cast to this type to enforce a string to be a valid translation key
 */
export type TI18nKey = ParseKeysByFallbackNs<Record<string, string>>

export default i18n
